import { render } from "./Impressum.vue?vue&type=template&id=1de41576"
import script from "./Impressum.vue?vue&type=script&lang=js"
export * from "./Impressum.vue?vue&type=script&lang=js"

import "./Impressum.vue?vue&type=style&index=0&id=1de41576&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__